import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";
import AddToBasketButton from "./addToBasketButton";
import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
import { IconErrorCircle } from "../../assets/icons";
import LazyLoad from "react-lazyload";
import Skeleton from "react-loading-skeleton";
function CardTileH6({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
  hasReserveDetail_V2,
}) {
  const [loaded, setLoaded] = useState(false);
  return isMobile ? (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center h-100">
        <LazyLoad>
          {/* <img
            src={itemImgSrc + "?width=200"}
            className="w-100 rounded-3"
            alt={amusementName}
            loading="lazy"
          /> */}
          <div style={{ position: "relative", width: "100%", height: "138px" }}>
            {!loaded && (
              <Skeleton height="100%" width="100%" className="rounded-3" />
            )}
            <img
              src={itemImgSrc + "?width=200"}
              alt={amusementName}
              className="rounded-3 mb-1"
              style={{
                display: loaded ? "block" : "none",
                width: "100%",
              }}
              onLoad={() => setLoaded(true)}
            />
          </div>
        </LazyLoad>
        <Card.Body className="px-0 pb-0">
          <h6 className="text-black fw-bold fs-normal">{amusementName}</h6>
          {hasReserveDetail_V2 ? (
            <Card.Text className="text-black-06 ">
              {amusementFinalPrice > amusementPrice ? (
                <>
                  <span className=" text-decoration-line-throught-rotate border-secondary">
                    <SplitNumber number={amusementFinalPrice} />
                  </span>
                  <span>تومان</span>
                </>
              ) : (
                ""
              )}
            </Card.Text>
          ) : (
            "عدم امکان رزرو"
          )}
        </Card.Body>
        <Card.Footer className="bg-white pt-0 px-0 border-0">
          {hasReserveDetail_V2 ? (
            <AddToBasketButton onClick={handleClick} price={amusementPrice} />
          ) : (
            <div className=" fs-07">
              <IconErrorCircle fillColor="#444" />
              در حال حاضر رزرو غیرفعال است
            </div>
          )}
        </Card.Footer>
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center h-100">
        <LazyLoad>
          {/* <img
            src={itemImgSrc + "?width=210"}
            className="w-100 rounded-3"
            alt={amusementName}
            loading="lazy"
          /> */}
          <div style={{ position: "relative", width: "100%", height: "150px" }}>
            {!loaded && (
              <Skeleton height="100%" width="100%" className="rounded-3" />
            )}
            <img
              src={itemImgSrc + "?width=210"}
              alt={amusementName}
              className="rounded-3 mb-1"
              style={{
                display: loaded ? "block" : "none",
                width: "100%",
              }}
              onLoad={() => setLoaded(true)}
            />
          </div>
        </LazyLoad>
        <Card.Body className="px-0 pb-0">
          <h6 className="text-black fw-bold fs-normal pb-3 border-bottom">
            {amusementName}
          </h6>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
          {hasReserveDetail_V2 ? (
            ""
          ) : (
            <div className="text-secondary">عدم امکان رزرو</div>
          )}
        </Card.Body>
        {hasReserveDetail_V2 ? (
          <Card.Footer className="bg-white border-0 ">
            <Row className="gx-0">
              <Col className="my-auto">
                {amusementFinalPrice > amusementPrice ? (
                  <>
                    <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    <span className="fs-08 ps-1">تومان</span>
                  </>
                ) : (
                  ""
                )}
                <div className="fw-bold text-black">
                  <span className=" text-dark pe-1">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  تومان
                </div>
              </Col>
              <Col xs="auto" className="my-auto">
                <AddToBasketRoundedButton onClick={handleClick} />
              </Col>
            </Row>
          </Card.Footer>
        ) : (
          <Card.Footer className="bg-white border-0 fs-07">
            <IconErrorCircle fillColor="#444" />
            در حال حاضر رزرو غیرفعال است
          </Card.Footer>
        )}
      </Card>
    </Link>
  );
}
export default CardTileH6;
